import { ReactNode } from 'react'
import styles from './MobilePreview.module.scss'
import CustomScrollbar from '@/components/CustomScrollbar/CustomScrollbar'

export default function MobilePreview({ children }: { children: ReactNode }) {
  return (
    <div className={styles.phone} data-cy="mobile-preview">
      <div className={styles['phone-notch']} />

      <div className={styles['phone-screen']}>
        <CustomScrollbar>
          <div className={styles.container}>{children}</div>
        </CustomScrollbar>
      </div>
      <div className={styles['phone-frame']} />
    </div>
  )
}
